module.exports = __webpack_public_path__ + "img/70.050e5907.png";